export default __webpack_public_path__ + "static/neue-haas-grotesk-display-66-medium-italic-fdea2dedeba98d8f900ce84a9f62a635.woff";